// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import AlertError from "@synd/XDL/Icons/NotificationErrorCircle";
import AlertInfo from "@synd/XDL/Icons/NotificationInfoCircle";
import AlertSuccess from "@synd/XDL/Icons/NotificationSuccessCheckCircle";
import AlertWarning from "@synd/XDL/Icons/NotificationWarningTriangle";
import Close from "@synd/XDL/Icons/Close";
import { xBaseTheme } from "@synd/XDL/types";
import { color, hideElementOnPrint } from "@synd/XDL/Utilities";
import { css } from "styled-components";
import { fontConfig } from "@synd/XDL/PreStyle/typography";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        mergeCss: true,
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            color: "common.ui6",
            css: css`
                position: absolute;
                top: 12px;
                right: 3px;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                svg {
                    color: ${color("common.ui6")};
                }
                &:hover ${IconWrapper} {
                    color: ${color("common.ui10")};
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 10,
            color: "common.ui6",
            css: css`
                width: 12px;
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 18,
            css: css`
                margin-top: 2px;
                margin-right: 10px;
            `,
        },
        iconSrcByMessage: {
            success: AlertSuccess,
            warning: AlertWarning,
            danger: AlertError,
            info: AlertInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                &,
                ${TypographyStyle} {
                    font-size: ${fontConfig.small.size}px;
                    line-height: ${fontConfig.small.lineHeight};
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                border-radius: 4px;
                ${hideElementOnPrint}
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
                padding: 14px 27px 14px 12px;
                margin-top: 2px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
